"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require("./polyfills");
// layout
require("./layout");
// style
require("@deepmap/hdm-web-map-sdk/styles/index.scss");
const system_1 = require("./util/system");
const hdm_web_map_sdk_1 = require("@deepmap/hdm-web-map-sdk");
const config = Object.assign({}, system_1.getConfig({
    projectName: 'mathematikon_basemap',
}), {
    target: 'deepMap-tap-handler'
});
try {
    const map = hdm_web_map_sdk_1.DeepMapFactory.bootstrap(config);
    map.setMapViewControllerDidStart(function () {
        if (config.projectName === 'mathematikon_basemap') {
            map.moveToFeatureByOriginalSerial('hdmi_office', false, true);
        }
        console.log("DeepMap initiated!");
        map.addTapHandler((queryPoint, zoomLevel, features, localFeatures) => {
            console.log('debug', queryPoint, zoomLevel, features, localFeatures);
            cleanup();
            const currentFeature = getCurrentFeature(features, zoomLevel);
            if (currentFeature) {
                if (overviewOrDetailZoomLevel(zoomLevel)) {
                    if (featureIsArea(currentFeature)) {
                        appendDemoMessage("tap on area, zoom to");
                        showFeatureDialog(currentFeature);
                        console.log("feature", currentFeature);
                        map.zoomTo(currentFeature);
                    }
                }
                else {
                    appendDemoMessage("tap on detail element, select feature");
                    showFeatureDialog(currentFeature);
                    console.log("feature", currentFeature);
                    map.select(currentFeature);
                }
            }
            else {
                if (localFeatures.length > 0) {
                    appendDemoMessage("some display features found");
                    console.log("feature", localFeatures);
                }
                else {
                    appendDemoMessage("ERROR: no detail feature");
                }
            }
        });
    });
    map.setMapViewControllerFailedStart(function (error) {
        console.log("error", error);
    });
    function showFeatureDialog(feature) {
        const popupFeature = {
            "name": feature.properties.name,
            "level": feature.properties.level,
            "entity_type": feature.properties.entity_type
        };
        document.getElementById("info").innerHTML = popupFeature.name + " - " + popupFeature.level + " - " + popupFeature.entity_type;
    }
    function appendDemoMessage(message) {
        const ulElement = document.getElementById("log").childNodes[1];
        const liElement = document.createElement("li");
        liElement.innerHTML = message;
        ulElement.insertBefore(liElement, ulElement.childNodes[0]);
    }
    function cleanup() {
        map.clearSelections();
    }
    function getCurrentFeature(features, zoomLevel) {
        if (overviewOrDetailZoomLevel(zoomLevel)) {
            return findHall(features);
        }
        else {
            return findBooth(features);
        }
    }
    function overviewOrDetailZoomLevel(zoomLevel) {
        return zoomLevel < map.firstDetailZoomLevel;
    }
    function findHall(features) {
        return findFeature(features, featureIsArea);
    }
    function findBooth(features) {
        return findFeature(features, featureIsBooth);
    }
    function findFeature(features, featureIsMethod) {
        for (let index = 0; index < features.length; index++) {
            if (featureIsMethod(features[index])) {
                return features[index];
            }
        }
        return undefined;
    }
    function featureIsArea(feature) {
        return feature.properties.entity_type === 'AREA';
    }
    function featureIsBooth(feature) {
        return feature.properties.entity_type === 'BOOTH';
    }
}
catch (e) {
    console.log(e);
}
